module.exports = (__webpack_require__("dll-reference mdfCore"))("./index.ts");